<div class="password-modal">
  <div class="password-modal__header">
    <h3 class="password-modal__title component-title">
      {{ 'user-profile.security.twoFactor.title' | translate }}
    </h3>
    <button mat-icon-button (click)="onCancel()" aria-label="Close">
      <app-icon class="password-modal__cross-icon" [icon]="iconName.CROSS" />
    </button>
  </div>

  <span class="password-modal__subtitle component-subtitle">
    @if (toggleStatus.action === 'enabled') {
      {{ 'user-profile.security.twoFactor.steps.confirmPassword.subtitleEnable' | translate }}
    } @else {
      {{ 'user-profile.security.twoFactor.steps.confirmPassword.subtitleDisable' | translate }}
    }
  </span>

  <form [formGroup]="passwordForm" (ngSubmit)="onConfirm()">
    <div class="password-modal__input-wrapper">
      <label for="password" class="change-password__password-label component-subtitle">
        {{ 'loginPageComponent.loginFormComponent.password.label' | translate }}
      </label>
      <div class="password-modal__input-container">
        <input
          [type]="isPasswordVisible() ? inputType.TEXT : inputType.PASSWORD"
          [class.error]="
            errorMessage() ||
            (passwordForm.get('password')?.hasError('required') &&
              passwordForm.get('password')?.touched)
          "
          formControlName="password"
          id="password"
          (input)="errorMessage.set('')"
          class="password-modal__input"
          placeholder="{{
            'user-profile.security.twoFactor.steps.confirmPassword.placeholder' | translate
          }}"
        />
        <app-icon
          class="button--toggle"
          [icon]="isPasswordVisible() ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
          (click)="togglePasswordVisibility()"
        />
      </div>
      @if (
        passwordForm.get('password')?.hasError('required') && passwordForm.get('password')?.touched
      ) {
        <span class="password-modal__error password-modal__error--required">
          {{ 'user-profile.security.twoFactor.steps.confirmPassword.required' | translate }}
        </span>
      }

      @if (errorMessage() && !passwordForm.get('password')?.hasError('required')) {
        <span class="password-modal__error password-modal__error--server">
          {{ errorMessage() }}
        </span>
      }
    </div>

    <div class="password-modal__actions">
      <button
        type="button"
        class="password-modal__button password-modal__button--cancel"
        (click)="onCancel()"
        [disabled]="isLoading()"
      >
        {{ 'user-profile.security.twoFactor.steps.confirmPassword.cancelButton' | translate }}
      </button>
      <button
        type="submit"
        class="password-modal__button password-modal__button--confirm"
        [disabled]="isLoading()"
      >
        @if (isLoading()) {
          @if (toggleStatus.action === 'enabled') {
            {{ 'user-profile.security.twoFactor.steps.confirmPassword.enabling' | translate }}
          } @else {
            {{ 'user-profile.security.twoFactor.steps.confirmPassword.disabling' | translate }}
          }
        } @else {
          {{ 'user-profile.security.twoFactor.steps.confirmPassword.confirmButton' | translate }}
        }
      </button>
    </div>
  </form>
</div>
